module.exports = __webpack_public_path__ + "static/media/loc1_img2.6709a46c.jpg";